import { render } from "./TableRowMenuItem.vue?vue&type=template&id=790f9bda"
import script from "./TableRowMenuItem.vue?vue&type=script&lang=ts"
export * from "./TableRowMenuItem.vue?vue&type=script&lang=ts"
script.render = render

export default script